/* ==========================================================================
   OMERTÀ — shared behaviour
   Deliberately small. Everything here is progressive enhancement: with JS
   disabled the site still renders, reads and sells.
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal on scroll ------------------------------------------------ */

  function initReveal() {
    var els = document.querySelectorAll('.o-reveal:not(.is-in)');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Header: hide on scroll down, reveal on scroll up ---------------- */

  function initHeader() {
    var header = document.querySelector('[data-omerta-header]');
    if (!header) return;

    var last = window.scrollY;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      header.classList.toggle('is-stuck', y > 8);

      // Never hide while a menu or search panel is open.
      if (!header.hasAttribute('data-open')) {
        var goingDown = y > last && y > 200;
        header.classList.toggle('is-hidden', goingDown);
      }

      last = y;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  /* ---- Mobile menu drawer --------------------------------------------- */

  function initDrawer() {
    var header = document.querySelector('[data-omerta-header]');
    var drawer = document.querySelector('[data-omerta-drawer]');
    var openBtn = document.querySelector('[data-omerta-drawer-open]');
    var closeBtn = document.querySelector('[data-omerta-drawer-close]');
    if (!drawer || !openBtn) return;

    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      // Force a frame so the transition runs from the closed state.
      window.requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      openBtn.setAttribute('aria-expanded', 'true');
      if (header) header.setAttribute('data-open', '');
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      openBtn.setAttribute('aria-expanded', 'false');
      if (header) header.removeAttribute('data-open');
      window.setTimeout(function () { drawer.hidden = true; }, reduceMotion ? 0 : 320);
      if (lastFocused) lastFocused.focus();
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    drawer.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-omerta-drawer-overlay')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });

    // Keep focus inside the drawer while it is open.
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = drawer.querySelectorAll('a[href], button:not([disabled])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function init() {
    initReveal();
    initHeader();
    initDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Sections re-render in the theme editor — re-bind on each load.
  document.addEventListener('shopify:section:load', init);
})();
